/* HH: Newsletter-Anmeldung fuer Fuss, Popup und spaeter das Quiz (Leitstand 21.10.2026).
   Sendet erst beim Absenden an Klaviyos Client-API (POST /client/subscriptions, oeffentlicher
   Schluessel, kein Token), ohne klaviyo.js und ohne Cookies. Liste Expert Circle Vm5MMU mit
   Double-Opt-In: Klaviyo schickt die Bestaetigungsmail, der Welcome-Flow den Code.
   Speicher (alle ohne Kennung, nur Merker): localStorage hh-nl-angemeldet, hh-nl-ruhe
   (Zeitstempel nach Schliessen, sieben Tage), sessionStorage hh-nl-zeit (aktive Sekunden),
   hh-nl-gezeigt (einmal je Sitzung). */
(function () {
  if (window.hhNewsletter) return;

  var FIRMA = 'VbacZe';
  var LISTE = 'Vm5MMU';
  var REVISION = '2026-10-15';
  var RUHE_MS = 7 * 24 * 60 * 60 * 1000;
  var POPUP_NACH_S = 90;
  var EXIT_FRUEHESTENS_S = 30; // Marco 21.10.2026: Exit-Intent fruehestens nach 30 s aktiver Zeit

  function lies(speicher, k) { try { return window[speicher].getItem(k); } catch (e) { return null; } }
  function schreib(speicher, k, v) { try { window[speicher].setItem(k, v); } catch (e) {} }

  function anmelden(email, quelle, eigenschaften) {
    var props = { hh_quelle: quelle };
    if (eigenschaften) for (var k in eigenschaften) props[k] = eigenschaften[k];
    return fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + FIRMA, {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', revision: REVISION },
      body: JSON.stringify({ data: {
        type: 'subscription',
        attributes: {
          custom_source: 'HH Theme ' + quelle,
          profile: { data: { type: 'profile', attributes: {
            email: email,
            properties: props,
            subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
          } } }
        },
        relationships: { list: { data: { type: 'list', id: LISTE } } }
      } })
    }).then(function (r) {
      if (r.status !== 202 && !r.ok) throw new Error('Klaviyo ' + r.status);
      schreib('localStorage', 'hh-nl-angemeldet', '1');
    });
  }

  var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function verbinde(form) {
    var feld = form.querySelector('input[type="email"]');
    var falle = form.querySelector('input[name="hh_nl_website"]');
    var knopf = form.querySelector('button[type="submit"]');
    var status = form.querySelector('.hh-nl__status');
    function zeige(text, art) { status.textContent = text; status.dataset.art = art || ''; }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (form.dataset.laeuft) return;
      var email = (feld.value || '').trim();
      if (!EMAIL.test(email)) {
        feld.setAttribute('aria-invalid', 'true');
        zeige('Bitte gib eine gültige E-Mail-Adresse ein.', 'fehler');
        feld.focus();
        return;
      }
      feld.removeAttribute('aria-invalid');
      var fertig = function () {
        form.classList.add('hh-nl__form--fertig');
        zeige('Fast geschafft: Bitte bestätige Deine Anmeldung in der E-Mail, die wir Dir gerade geschickt haben.', 'ok');
      };
      if (falle && falle.value) { fertig(); return; }
      form.dataset.laeuft = '1';
      knopf.disabled = true;
      zeige('Einen Moment …', '');
      anmelden(email, form.dataset.quelle || 'footer').then(fertig, function () {
        zeige('Das hat nicht geklappt. Bitte versuche es noch einmal.', 'fehler');
      }).then(function () { delete form.dataset.laeuft; knopf.disabled = false; });
    });
  }

  /* ---------- Popup ---------- */

  function popup() {
    window.hhNewsletter.bannerOffen = bannerOffen; // auch fuer die Warenkorb-Frage (assets/hh-warenkorb-frage.js)
    var box = document.getElementById('hh-nl-popup');
    if (!box) return;
    var karte = box.querySelector('[role="dialog"]');
    var params = new URLSearchParams(location.search);
    var debug = params.get('hh_popup') === '1';
    var offen = false;
    var vorher = null;

    function fokussierbar() {
      return Array.prototype.filter.call(
        karte.querySelectorAll('a[href], button:not([disabled]), input:not([tabindex="-1"])'),
        function (el) { return el.offsetParent !== null; });
    }
    function taste(e) {
      if (e.key === 'Escape') { zu(); return; }
      if (e.key !== 'Tab') return;
      var f = fokussierbar(); if (!f.length) return;
      var erst = f[0], letzt = f[f.length - 1];
      if (e.shiftKey && document.activeElement === erst) { e.preventDefault(); letzt.focus(); }
      else if (!e.shiftKey && document.activeElement === letzt) { e.preventDefault(); erst.focus(); }
    }
    function auf() {
      if (offen) return;
      offen = true;
      schreib('sessionStorage', 'hh-nl-gezeigt', '1');
      vorher = document.activeElement;
      box.hidden = false;
      document.documentElement.classList.add('hh-nl-offen');
      document.addEventListener('keydown', taste);
      var feld = karte.querySelector('input[type="email"]');
      setTimeout(function () { (feld || karte).focus(); }, 30);
    }
    function zu() {
      if (!offen) return;
      offen = false;
      box.hidden = true;
      document.documentElement.classList.remove('hh-nl-offen');
      document.removeEventListener('keydown', taste);
      if (lies('localStorage', 'hh-nl-angemeldet') !== '1') schreib('localStorage', 'hh-nl-ruhe', String(Date.now()));
      if (vorher && vorher.focus) vorher.focus();
    }
    Array.prototype.forEach.call(box.querySelectorAll('[data-hh-nl-zu]'), function (el) {
      el.addEventListener('click', zu);
    });

    if (debug) { auf(); return; }
    if (window.Shopify && window.Shopify.designMode) return;
    if (params.get('utm_medium') === 'email') { schreib('sessionStorage', 'hh-nl-gezeigt', '1'); return; }
    if (lies('localStorage', 'hh-nl-angemeldet') === '1') return;
    if (lies('sessionStorage', 'hh-nl-gezeigt') === '1') return;
    var ruhe = parseInt(lies('localStorage', 'hh-nl-ruhe') || '0', 10);
    if (ruhe && Date.now() - ruhe < RUHE_MS) return;

    /* Usercentrics: solange das Banner eine Entscheidung verlangt, wartet das Popup. V3 bietet
       __ucCmp.isConsentRequired() (Promise), aeltere Fassungen UC_UI.isConsentRequired(). Ohne API
       und ohne Usercentrics-Element im DOM ist kein Banner sichtbar (etwa bei blockiertem CMP). */
    /* Gemessen 21.10.2026 auf der Vorschau: __ucCmp existiert, die CMP initialisiert dort aber nicht,
       und isConsentRequired() kehrt nie zurueck. Deshalb nach 2 s auf das DOM zurueckfallen. */
    function bannerOffen() {
      var rueckfall = function () { return !!document.getElementById('usercentrics-cmp-ui'); };
      try {
        if (window.__ucCmp && typeof window.__ucCmp.isConsentRequired === 'function') {
          return Promise.race([
            Promise.resolve(window.__ucCmp.isConsentRequired()).then(function (x) { return !!x; }, rueckfall),
            new Promise(function (r) { setTimeout(function () { r(rueckfall()); }, 2000); })
          ]);
        }
        if (window.UC_UI && typeof window.UC_UI.isConsentRequired === 'function') {
          return Promise.resolve(!!window.UC_UI.isConsentRequired());
        }
      } catch (e) {}
      return Promise.resolve(rueckfall());
    }

    /* Warenkorb offen (Schublade oder /cart): kein Popup darueber, spaeter erneut versuchen
       (T-237, Marco 22.10.2026). Dawn setzt beim Oeffnen der Schublade die Klasse active.
       Mit Ware im Warenkorb wartet es ebenfalls: Dann hat die Warenkorb-Frage Vorrang (Plan 21.10.2026,
       Abschnitt 2, Marco 22.10.2026). Die Zaehlblase am Warenkorb-Symbol gibt es nur mit Ware darin. */
    function warenkorbOffen() {
      return !!document.querySelector('cart-drawer.active') || !!document.getElementById('main-cart-items') ||
        !!document.querySelector('#cart-icon-bubble .cart-count-bubble');
    }

    var wartet = false;
    function versuche() {
      if (offen || wartet || lies('sessionStorage', 'hh-nl-gezeigt') === '1') return;
      if (warenkorbOffen()) { setTimeout(versuche, 3000); return; }
      wartet = true;
      bannerOffen().then(function (blockiert) {
        wartet = false;
        if (blockiert) { setTimeout(versuche, 3000); return; }
        auf();
      });
    }
    ['UC_CONSENT', 'UC_UI_CMP_EVENT'].forEach(function (ev) {
      window.addEventListener(ev, function () { if (bereit) versuche(); });
    });

    var sekunden = parseInt(lies('sessionStorage', 'hh-nl-zeit') || '0', 10) || 0;
    var bereit = sekunden >= POPUP_NACH_S;
    if (bereit) { versuche(); return; }
    var uhr = setInterval(function () {
      if (document.visibilityState !== 'visible') return;
      sekunden += 1;
      schreib('sessionStorage', 'hh-nl-zeit', String(sekunden));
      if (sekunden >= POPUP_NACH_S) { clearInterval(uhr); bereit = true; versuche(); }
    }, 1000);

    if (window.matchMedia && window.matchMedia('(pointer: fine)').matches) {
      document.addEventListener('mouseout', function (e) {
        if (e.relatedTarget || e.clientY > 0 || sekunden < EXIT_FRUEHESTENS_S) return;
        bereit = true;
        versuche();
      });
    }
  }

  window.hhNewsletter = { anmelden: anmelden };

  function start() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-hh-nl-form]'), verbinde);
    popup();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
